import { useLocation } from "react-router-dom";
import styles from "./BlogsPage.module.css";
import { useNavigate } from "react-router-dom";

import {
  BreadCrumb,
  Banner,
} from "../../../components/shared";

const blogData = [
  {
    id: 1,
    category: "Health & Wellness",
    title: "5 Daily Vitamins Your Body Needs",
    description:
      "Discover the essential vitamins and minerals that support immunity, energy, and overall wellness. Learn how small daily habits can improve your long-term health naturally.",
    image:
      "https://media.istockphoto.com/id/2238752326/photo/protein-powder-with-plastic-bottle-on-white-background-nutrition-photostock.jpg?s=612x612&w=0&k=20&c=2VC4guWKtRg96pdGW-YbK21j_CyMXHkG0v_5HXeh9Ok=",
    author: "Dr. Sarah Johnson",
    date: "12 May 2026",
  },
  {
    id: 2,
    category: "Pharmacy Care",
    title: "How Pharmacists Help Improve Patient Care",
    description:
      "Modern pharmacies offer more than medicines. From medication guidance to wellness support, pharmacists play a key role in helping people live healthier lives.",
    image:
      "https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop",
    author: "VITAURA",
    date: "10 May 2026",
  },
  {
    id: 3,
    category: "Nutrition",
    title: "Healthy Eating Tips for Better Immunity",
    description:
      "A balanced diet is one of the best ways to strengthen your immune system. Explore healthy foods, hydration tips, and nutritional supplements for everyday wellness.",
    image:
      "https://media.istockphoto.com/id/2134696239/video/close-up-of-male-hands-pointing-at-bottle-of-multivitamin-with-thumbs-up-gesture-while.jpg?s=640x640&k=20&c=xWI4YRP44of_mhB9ydHKbA_aCz4K3UPADqRRt5qkABI=",
    author: "Nutrition Expert",
    date: "08 May 2026",
  },
  {
    id: 4,
      category: "Nutrition",
       title: "The Importance of Daily Nutritional Support",
    description:
      "Proper nutrition plays a vital role in maintaining energy, supporting immunity, and promoting overall health. Vitaura develops nutritional solutions designed to complement a balanced lifestyle .",
    image:
      "https://media.istockphoto.com/id/1162496068/photo/black-plastic-container-full-of-sport-nutrition-blue-jump-rope-with-wooden-handles-on-the.jpg?s=612x612&w=0&k=20&c=2it6Rfx4RozjaXeV-KHbM6Ja1LVn-bZY9tNw7-IwrRQ=",
    author: "Nutrition Experts",
    date: "04 July 2026",
  },
];

const BlogsPage = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];
  const navigate = useNavigate();
  return (
    <section className={styles.about__wrapper}>
      <BreadcrumbBanner
        newPath={newPath}
        heading="Explore trusted articles on healthcare, nutrition, fitness, medicines, and everyday wellness"
        imageUrl="https://cdn.pixabay.com/photo/2021/08/19/09/09/medicine-6557489_1280.jpg"
      />

      {/* Intro Section */}
      <div className={styles.blog__intro}>
       

        <h1 className={styles.main__heading}>
          Health & Wellness Articles
        </h1>

        <p className={styles.main__paragraph}>
          Explore expert-written healthcare articles, wellness tips, nutrition
          advice, skincare guidance, and pharmacy updates designed to help you
          live a healthier and more balanced life.
        </p>
      </div>

      {/* Blog Cards */}
      <div className={styles.blogs__container}>
        {blogData.map((blog) => (
          <div key={blog.id} className={styles.blog__card}>
            <div className={styles.blog__image}>
              <img src={blog.image} alt={blog.title} />
            </div>

            <div className={styles.blog__content}>
              <span className={styles.category}>{blog.category}</span>

              <h2>{blog.title}</h2>

              <p>{blog.description}</p>

              <div className={styles.blog__footer}>
                <span>{blog.author}</span>
                <span>{blog.date}</span>
              </div>

                  <button
  onClick={() => window.open("/products_theory_report.pdf", "_blank")}
>
  More
</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "Blogs", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default BlogsPage;